import { CheckboxGroup } from 'ui-builder';

export default CheckboxGroup;
